import { convertLegacyRouteRefs } from '@backstage/core-compat-api';
import { createPlugin } from '@backstage/core-plugin-api';
import { CreateAppRouteBinder } from '@backstage/frontend-app-api';

import { ExternalRoutes } from './routes';

export const confidenceOnboardingPlugin = createPlugin({
  id: 'confidence-onboarding',
  externalRoutes: ExternalRoutes,
});

export const bindOnboardingRoutes = (
  bind: CreateAppRouteBinder,
  extraRoutes?: Parameters<typeof convertLegacyRouteRefs>[0],
) => {
  bind(
    convertLegacyRouteRefs(confidenceOnboardingPlugin.externalRoutes),
    convertLegacyRouteRefs(extraRoutes ?? {}),
  );
};
